import { render, staticRenderFns } from "./UrmP2Plug.vue?vue&type=template&id=89aa17d4"
import script from "./UrmP2Plug.vue?vue&type=script&lang=js"
export * from "./UrmP2Plug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports